import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import "react-datepicker/dist/react-datepicker.css";
import bgimage from '../../../../images/doc.png';
import vehicle from '../../../../images/vehicle/default_vehicle.png';
import swal from "sweetalert2";
import DatePicker, { DateObject } from "react-multi-date-picker";
import FileUpload from "react-material-file-upload";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { addDays } from 'date-fns';

const EditVehicle = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { ID } = location.state || {};

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;

    const [data, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [attachments, setattachments] = useState([]);

    // category
    const [categoryoption, setCategoryOption] = useState([]);
    const [catego, setcatego] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/vehiclecategory`);
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.vehiclecategory_name,
                }));
                setCategoryOption(formattedsource);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    // document type
    const [doctypeopt, setdoctypopt] = useState([]);
    const [doctype, setdoctype] = useState('');
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/documenttype`);
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.documenttype_name,
                }));
                setdoctypopt(formattedsource);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    // use states for form fields
    const [brand, setbrand] = useState('');
    const [model, setmodel] = useState('');
    const [number, setnumber] = useState('');
    const [manufactured_date, setmanufacDate] = useState('');
    const [manufactured_datedisp, setmanufacDatedisp] = useState(null);
    const [registration_date, setregistrationdate] = useState('');
    const [registration_dateDisp, setregistrationdateDisp] = useState(null);
    const [color, setcolor] = useState('');
    const [fuel_type, setfueltype] = useState(null);
    const [purpose, setporpose] = useState(null);
    const [newpurpose, setnewporpose] = useState(null);
    const [fuel_capacity, setcapacity] = useState('');
    const [mileage, setmileage] = useState('');
    const [maintanencedate, setmaintanencedate] = useState('');
    const [maintanencedateDisp, setmaintanencedateDisp] = useState(null);
    const [description, setdescription] = useState('');
    const [image, setimage] = useState(null);
    const [imageurl, setimageurl] = useState(null);
    const [deleteimage, setdeleteimage] = useState(0);

    const [insurance, setinsurance] = useState(null);
    const [insurance_company, setinsurancecompany] = useState('');
    const [insurance_start_date, setinsurance_start_date] = useState('');
    const [insurance_start_dateDisp, setinsurance_start_dateDisp] = useState(null);

    const [insurance_end_date, setinsurance_end_date] = useState('');
    const [insurance_end_dateDisp, setinsurance_end_dateDisp] = useState(null);
    const [insurance_prolicy, setinsurance_policy] = useState('');

    const [files, setFiles] = useState(null);
    const imageInputRef = useRef(null);
    const [isChecked, setIsChecked] = useState(false);

    // drop down options static
    const vehicle_purpose = [
        { value: 1, label: "Delivery" },
        { value: 2, label: "Office Work" },
        { value: 3, label: "Others" }
    ];

    const options_fuelType = [
        { value: 1, label: "Petrol" },
        { value: 2, label: "Diesel" },
        { value: 3, label: "Electric" },
    ];

    // date convertion
    function formatDateToDDMMYYYY(dateString) {
        if (dateString) {
            const [year, month, day] = dateString.split("-");
            return `${day}-${month}-${year}`;
        }
        return '';
    }

    // fetch data
    useEffect(() => {
        if (ID) {
            axios.get(`${baseURL}/manage_vehicle/${ID}`)
                .then(response => {
                    const data = response.data.data;
                    setcatego(data.vehicle_category);
                    setbrand(data.vehicle_brand);
                    setmodel(data.vehicle_model);
                    setnumber(data.vehicle_number);
                    if (data.manufactured_date) {
                        setmanufacDate(data.manufactured_date);
                    }
                    setmanufacDatedisp(formatDateToDDMMYYYY(data.manufactured_date));
                    setregistrationdate(data.registration_date);
                    setregistrationdateDisp(formatDateToDDMMYYYY(data.registration_date));
                    setcolor(data.vehicle_color);
                    setfueltype(data.fuel_type);
                    if (data.fuel_type === 1 || data.fuel_type === 2) {
                        setSelectedFuelType(options_fuelType.find(option => option.value === data.fuel_type))
                    }
                    setporpose(data.vehicle_purpose);
                    setnewporpose(data.vehicle_purpose);
                    setcapacity(data.fuel_capacity);
                    setmileage(data.average_mileage);
                    setmaintanencedate(data.upcoming_maintenance_date);
                    setmaintanencedateDisp(formatDateToDDMMYYYY(data.upcoming_maintenance_date));
                    if (data.description) {
                        setdescription(data.description);
                    }
                    setinsurance(data.insurance_information);
                    if (data.insurance_information === 1) {
                        setIsChecked(true);
                        setinsurancecompany(data.insurance_company);
                        setinsurance_policy(data.insurance_policy_number);
                        if (data.insurance_start_date) {
                            setinsurance_start_date(data.insurance_start_date);
                            setinsurance_start_dateDisp(formatDateToDDMMYYYY(data.insurance_start_date));
                        }
                        if (data.insurance_end_date) {
                            setinsurance_end_date(data.insurance_end_date);
                            setinsurance_end_dateDisp(formatDateToDDMMYYYY(data.insurance_end_date));
                        }

                    }
                    setdoctype(data.document_type);
                    setimageurl(data.vehicle_image);


                    setData(response.data.data);
                    setHasFetched(true);
                    setattachments(response.data.data.attachmentsrelation);
                })
                .catch(error => {
                    console.log('There was an error fetching the data!', error);
                    setHasFetched(true);
                });
        }
    }, [ID]);

    useEffect(() => {
        if (isChecked) {
            setinsurance(1);
        } else {
            setinsurance(0);
        }
    }, [isChecked]);

    // select multiple purpose
    const [selectedOptionsPorpose, setSelectedOptionsPorpose] = useState([]);
    useEffect(() => {
        if (newpurpose) {
            const selectedIds = newpurpose.split(',').map(id => parseInt(id));
            // console.log(selectedIds);
            const preselected = vehicle_purpose.filter(option => selectedIds.includes(option.value));
            // console.log(preselected);
            setSelectedOptionsPorpose(preselected);
        }
    }, [newpurpose]);

    // select multiple doctype
    const [selectedOptionsDoctype, setSelectedOptionsdoctype] = useState([]);
    useEffect(() => {
        if (doctype) {
            const selectedIds = doctype.split(',').map(id => parseInt(id));
            // console.log(selectedIds);
            const preselected = doctypeopt.filter(option => selectedIds.includes(option.value));
            // console.log(preselected);
            setSelectedOptionsdoctype(preselected);
        }
    }, [doctype, doctypeopt]);


    // Handle checkbox change
    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const fileHandler = (e) => {

        const file = e.target.files[0];
        if (file) {
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            const maxSizeKB = 50; // max size in KB

            if (!allowedTypes.includes(file.type)) {
                swal.fire('Error', 'Only JPG, JPEG, and PNG files are allowed.', 'error');
                e.target.value = null; // reset file input
                return;
            }

            if (file.size / 1024 > maxSizeKB) {
                swal.fire('Error', 'File size must be less than 50 KB.', 'error');
                e.target.value = null; // reset file input
                return;
            }
            setimage(file);
            setimageurl(null);
            setdeleteimage(0);
        }

    }

    function RemoveImage() {
        setimage(null);
        setimageurl(null);
        setdeleteimage(1);
    }

    const [selectedFuelType, setSelectedFuelType] = useState(null);

    const handlePurposeChange = (selectedOptions) => {
        setSelectedOptionsPorpose(selectedOptions);
        if (selectedOptions) {
            const ids = selectedOptions.map(option => option.value).join(','); // converts to "1,5,9"
            setporpose(ids);
        } else {
            setporpose(null);
        }
    }

    const handledoctypechange = (selectedOptions) => {
        const ids = selectedOptions.map(option => option.value).join(','); // converts to "1,5,9"
        setdoctype(ids);
    }

    const ConfirmationModal = () => {
        swal.fire({
            html: `
                <div class="alert alert-success px-2 py-2" role="alert">
                    Are You Sure Want to Update Vehicle
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>${categoryoption.find(option => option.value === catego).label} - ${brand}</b></p>
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                    <defs>
                     <style>.cls-2{fill:#273941}.cls-5{fill:#f6fafd}
                     </style>
                     </defs>
                     <g id="_03-smile" data-name="03-smile"><circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                     <path class="cls-2" d="M24 39c-7.168 0-13-4.935-13-11h2c0 4.962 4.935 9 11 9s11-4.038 11-9h2c0 6.065-5.832 11-13 11zM20 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6zM38 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6z"/>
                     <path d="M24 4c12.15 0 22 8.507 22 19h.975a23 23 0 0 0-45.95 0H2C2 12.507 11.85 4 24 4z" style="fill:#ffe369"/>
                     <path d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z" style="fill:#ffb32b"/>
                     <ellipse class="cls-5" cx="37" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 37 9)"/>
                     <ellipse class="cls-5" cx="30.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 30.745 4.5)"/>
                     <ellipse class="cls-5" cx="34" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 34 7)"/></g>
                     </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {

                const formData = new FormData();

                // Append regular fields
                formData.append('vehicle_category', catego);
                formData.append('vehicle_brand', brand);
                formData.append('vehicle_model', model);
                formData.append('vehicle_number', number);
                formData.append('manufactured_date', manufactured_date);
                formData.append('registration_date', registration_date);
                formData.append('vehicle_color', color);
                formData.append('vehicle_purpose', purpose);
                formData.append('fuel_type', fuel_type);
                formData.append('fuel_capacity', fuel_capacity);
                formData.append('average_mileage', mileage);
                formData.append('upcoming_maintenance_date', maintanencedate);
                formData.append('insurance_information', insurance);
                formData.append('description', description);
                formData.append('insurance_company', insurance_company);
                formData.append('insurance_policy_number', insurance_prolicy);
                formData.append('insurance_start_date', insurance_start_date);
                formData.append('insurance_end_date', insurance_end_date);
                formData.append('document_type', doctype);
                formData.append('delete_image', deleteimage);

                if (image) {
                    formData.append('vehicle_image', image);
                }

                if (files && files.length > 0) {
                    files.forEach((file, index) => {
                        formData.append('attachments[]', file);
                    });
                }

                // for (let pair of formData.entries()) {
                //     console.log(pair[0] + ':', pair[1]);
                // }


                axios.post(`${baseURL}/manage_vehicle/${ID}`, formData)
                    .then(response => {
                        navigate('/manage-vehicles', {
                            state: { toastMessage: 'Vehicle Updated Successfully!', toastType: 'success' }
                        });
                    }).catch(error => {
                        navigate('/manage-vehicles', {
                            state: { toastMessage: 'Vehicle Updation Failed', toastType: 'error' }
                        });
                        console.log(error);
                    });
            }
        });
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (!brand) {
            newErrors.brand = "This Field is Required.";
        }

        if (!model) {
            newErrors.model = "This Field is Required.";
        }

        if (!catego) {
            newErrors.catego = "This Field is Required.";
        }

        if (!number) {
            newErrors.number = "This Field is Required.";
        }

        if (!registration_date) {
            newErrors.redate = "This Field is Required.";
        }

        if (!purpose || purpose.trim() === '') {
            newErrors.purpose = "This field is required.";
        }

        if (!fuel_type) {
            newErrors.ftype = "This Field is Required.";
        }

        if (selectedFuelType && (selectedFuelType.label === "Petrol" || selectedFuelType.label === "Diesel")) {
            if (!fuel_capacity) {
                newErrors.capacity = "This Field is Required.";
            }
        }

        if (!mileage) {
            newErrors.mileage = "This Field is Required.";
        }

        if (!maintanencedate) {
            newErrors.mdate = "This Field is Required.";
        }

        if (isChecked) {
            if (!insurance_company) {
                newErrors.comp = "This Field is Required.";
            }
            if (!insurance_start_date) {
                newErrors.sdate = "This Field is Required.";
            }
            if (!insurance_end_date) {
                newErrors.edate = "This Field is Required.";
            }
            if (!insurance_prolicy) {
                newErrors.policy = "This Field is Required.";
            }
        }
        console.log(newErrors);
        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        } else {
            setErrors({});
        }

        ConfirmationModal();

        // const formData = new FormData();

        // // Append regular fields
        // formData.append('datetime', date);
        // formData.append('subscriber_id', filter_subs_id);
        // formData.append('product', filter_prods_id);
        // formData.append('complaint_type', complaint_type_id);
        // formData.append('complaint', complaint);

        // if (files && files.length > 0) {
        //     files.forEach((file, index) => {
        //         formData.append('attachments[]', file);
        //     });
        // }

        // for (let pair of formData.entries()) {
        //     console.log(pair[0] + ':', pair[1]);
        // }

        // axios.post(`${baseURL}/complaint`, formData)
        //     .then(response => {
        //         onClose();
        //         refresh();
        //         // window.location.reload();
        //     })
        //     .catch(error => {
        //         console.log('There was an error ', error);
        //     });
    };

    // useEffect (() => {
    //     console.log(errors);
    // }, [errors])

    const [fileerrors, setfileErrors] = useState([]);
    const handleFileChange = (selectedFiles) => {
        const maxFileSize = 5 * 1024 * 1024; // 5MB
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/gif",
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        const newErrors = [];
        const validFiles = selectedFiles.filter((file) => {
            if (!allowedTypes.includes(file.type)) {
                newErrors.push(`"${file.name}" is not a supported file type.`);
                return false;
            }
            if (file.size > maxFileSize) {
                newErrors.push(`"${file.name}" exceeds 5MB.`);
                return false;
            }
            return true;
        });

        setFiles(validFiles);
        setfileErrors(newErrors);
    };


    return (
        <>

            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Update Vehicle</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Maintenance Management</li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-vehicles'>Manage Vehicle</Link></li>
                    </ol>
                </div>
            </div>
            <label className='text-red fs-4 font-w600 mb-3'>Basic Information</label>
            <div className="row">
                <div className="col-lg-4 mb-3">
                    <label className="text-black font-w500 fs-7">Vehicle Category <span className="required">*</span></label>
                    <Select placeholder="Select Vehicle Category"
                        options={categoryoption}
                        onChange={(e) => setcatego(e.value)}
                        value={categoryoption.find(option => option.value === catego)}
                    />
                    {errors.catego && <div className="text-danger fs-8 mt-1">{errors.catego}</div>}
                </div>
                <div className="col-lg-4 mb-3">
                    <label className="text-black font-w500 fs-7">Vehicle Brand<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Vehicle Brand"
                        maxLength={300}
                        value={brand}
                        onChange={(e) => setbrand(e.target.value)}
                    />
                    {errors.brand && <div className="text-danger fs-8 mt-1">{errors.brand}</div>}
                </div>
                <div className="col-lg-4 mb-3">
                    <label className="text-black font-w500 fs-7">Vehicle Model<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Vehicle Model"
                        maxLength={300}
                        value={model}
                        onChange={(e) => setmodel(e.target.value)}
                    />
                    {errors.model && <div className="text-danger fs-8 mt-1">{errors.model}</div>}
                </div>
                <div className="col-lg-4 mb-3 ">
                    <label className="text-black font-w500 fs-7">Vehicle Number<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Vehicle Number"
                        maxLength={100}
                        value={number}
                        onChange={(e) => setnumber(e.target.value)}
                    />
                    {errors.number && <div className="text-danger fs-8 mt-1">{errors.number}</div>}
                </div>
                <div className="col-lg-4 mb-3">
                    <label className="text-black font-w500 fs-7">Manufactured Date</label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Manufactured Date'
                            value={manufactured_datedisp}
                            onChange={(date) => {
                                setmanufacDatedisp(date);
                                const formattedDate = date.format('YYYY-MM-DD');
                                setmanufacDate(formattedDate);
                            }}
                            format="DD-MM-YYYY"
                        />
                    </div>
                </div>
                <div className="col-lg-4 mb-3">
                    <label className="text-black font-w500 fs-7">Registration Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Registration Date'
                            value={registration_dateDisp}
                            onChange={(date) => {
                                setregistrationdateDisp(date);
                                const formattedDate = date.format('YYYY-MM-DD');
                                setregistrationdate(formattedDate);
                            }}
                            format="DD-MM-YYYY"
                        />
                    </div>
                    {errors.redate && <div className="text-danger fs-8 mt-1">{errors.redate}</div>}
                </div>
                <div className="col-lg-4 mb-3 ">
                    <label className="text-black font-w500 fs-7 ">Vehicle Color</label>
                    <input type="text" className="form-control" placeholder="Enter Vehicle Color"
                        maxLength={100}
                        value={color}
                        onChange={(e) => setcolor(e.target.value)}
                    />
                </div>
                <div className="col-lg-4 mb-3 ">
                    <label className="text-black font-w500 fs-7">Vehicle Purpose<span className="required">*</span></label>
                    <Select placeholder="Select Vehicle Purpose"
                        isMulti
                        onChange={handlePurposeChange}
                        options={vehicle_purpose}
                        value={selectedOptionsPorpose}
                    />
                    {errors.purpose && <div className="text-danger fs-8 mt-1">{errors.purpose}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Fuel Type<span className="required">*</span></label>
                    <Select placeholder="Select Fuel Type"
                        onChange={(e) => {
                            setfueltype(e.value);
                            setSelectedFuelType(e);
                        }}
                        value={options_fuelType.find(option => option.value === fuel_type) || null}
                        options={options_fuelType}
                    />
                    {errors.ftype && <div className="text-danger fs-8 mt-1">{errors.ftype}</div>}
                </div>
                {selectedFuelType && (selectedFuelType.label === "Petrol" || selectedFuelType.label === "Diesel") && (
                    <div className="col-lg-4 mb-4 ">
                        <label className="text-black font-w500 fs-7">Fuel Capacity<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Fuel Capacity in Liter"
                            maxLength={200}
                            value={fuel_capacity}
                            // onChange={(e) => setcapacity(e.target.value)}
                            onChange={(e) => {
                                const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                setcapacity(onlyNums);
                            }}
                        />
                        {errors.capacity && <div className="text-danger fs-8 mt-1">{errors.capacity}</div>}
                    </div>
                )}
                <div className="col-lg-4 mb-3 ">
                    <label className="text-black font-w500 fs-7">Average Mileage<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Average Mileage in Km"
                        maxLength={200}
                        value={mileage}
                        // onChange={(e) => setmileage(e.target.value)}
                        onChange={(e) => {
                            const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                            setmileage(onlyNums);
                        }}
                    />
                    {errors.mileage && <div className="text-danger fs-8 mt-1">{errors.mileage}</div>}
                </div>
                <div className="col-lg-4 mb-3">
                    <label className="text-black font-w500 fs-7 ">Upcoming Maintenance Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Upcoming Maintenance Date'
                            value={maintanencedateDisp}
                            minDate={addDays(new Date(), 1)}
                            onChange={(date) => {
                                setmaintanencedateDisp(date);
                                const formattedDate = date.format('YYYY-MM-DD');
                                setmaintanencedate(formattedDate);
                            }}
                            format="DD-MM-YYYY"
                        />
                    </div>
                    {errors.mdate && <div className="text-danger fs-8 mt-1">{errors.mdate}</div>}
                </div>
                <div className="col-lg-8 mb-3">
                    <label className="text-black font-w500 fs-7">Description</label>
                    <textarea rows={8} className="form-control" name="comment" placeholder="Description"
                        maxLength={255}
                        value={description}
                        onChange={(e) => setdescription(e.target.value)}
                    />
                </div>
                <div className="col-lg-4 mb-3">
                    <label className="text-black font-w500 fs-7 d-block">Vehicle  Image</label>
                    <span className='fs-8 text-gray-800'>Max Size: </span>
                    <span className='fs-8 text-danger'>50 KB</span>
                    <span className='fs-8 text-gray-800 ms-2'>Format: </span>
                    <span className='fs-8 text-danger'>.png, .jpg</span>
                    <div className="avatar-upload d-flex align-items-center">
                        <div className="change position-relative">
                            <div className="avatar-preview h-125px w-125px border" style={{ borderRadius: '10px' }}>
                                {imageurl && (
                                    <>
                                        <img
                                            id="saveImageFile"
                                            src={(imgBaseUrl && imageurl) ? imgBaseUrl + '/' + imageurl : vehicle}
                                            alt={image ? image.name : 'Default Avatar'}
                                            className="p-1 h-125px w-125px"
                                        />
                                    </>
                                )}
                                {!imageurl && (
                                    <img
                                        id="saveImageFile"
                                        src={image ? URL.createObjectURL(image) : vehicle}
                                        alt={image ? image.name : 'Default Avatar'}
                                        className="p-1 h-125px w-125px"
                                    />
                                )}
                            </div>
                            <div className="change-btn">
                                <input
                                    type="file"
                                    id="imageUpload"
                                    accept=".png, .jpg, .jpeg"
                                    style={{ display: 'none' }}
                                    onChange={fileHandler}
                                    ref={imageInputRef}
                                />
                                <div className="mt-2 d-flex justify-content-center gap-3">
                                    <Button
                                        className="btn-xs mb-2"
                                        variant="success"
                                        onClick={() => imageInputRef.current.click()}
                                    >
                                        <span className="">
                                            <i className="fa fa-upload color-success fs-5" />
                                        </span>
                                    </Button>
                                    <Button
                                        className="btn-xs mb-2"
                                        variant="danger"
                                        onClick={RemoveImage}
                                    >
                                        <span className="">
                                            <i className="fa fa-close color-danger fs-5" />
                                        </span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-check custom-checkbox mb-3">
                <input
                    checked={isChecked}
                    type="checkbox"
                    onChange={handleCheckboxChange}
                    className="form-check-input me-3"
                    id="customCheckBox1"
                />
                <label className='text-red fs-4 font-w600 mb-3'>Insurance Information</label>
            </div>
            {isChecked && (
                <div className='row'>
                    <div className="col-lg-4 mb-3 ">
                        <label className="text-black font-w500 fs-7">Insurance Company<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Insurance Company"
                            maxLength={300}
                            value={insurance_company}
                            onChange={(e) => setinsurancecompany(e.target.value)}
                        />
                        {errors.comp && <div className="text-danger fs-8 mt-1">{errors.comp}</div>}
                    </div>
                    <div className="col-lg-4 mb-3 ">
                        <label className="text-black font-w500 fs-7">Insurance Policy Number<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Insuance Policy Number"
                            maxLength={100}
                            value={insurance_prolicy}
                            onChange={(e) => setinsurance_policy(e.target.value)}
                        />
                        {errors.policy && <div className="text-danger fs-8 mt-1">{errors.policy}</div>}
                    </div>
                    <div className="col-lg-4 mb-3 ">
                        <label className="text-black font-w500 fs-7">Insurance Start Date<span className="required">*</span></label>
                        <div className='datepicker-wrapper d-flex'>
                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                            <DatePicker placeholder='Select Insurance Start Date'
                                value={insurance_start_dateDisp}
                                onChange={(date) => {
                                    setinsurance_start_dateDisp(date);
                                    const formatted = date.format('YYYY-MM-DD');
                                    setinsurance_start_date(formatted);
                                }}
                                format="DD-MM-YYYY"
                            />
                        </div>
                        {errors.sdate && <div className="text-danger fs-8 mt-1">{errors.sdate}</div>}
                    </div>
                    <div className="col-lg-4 mb-3 ">
                        <label className="text-black font-w500 fs-7">Insurance End Date<span className="required">*</span></label>
                        <div className='datepicker-wrapper d-flex'>
                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                            <DatePicker placeholder='Select Insurance End Date'
                                value={insurance_end_dateDisp}
                                minDate={insurance_start_dateDisp}
                                onChange={(date) => {
                                    setinsurance_end_dateDisp(date);
                                    const formatted = date.format('YYYY-MM-DD');
                                    setinsurance_end_date(formatted);
                                }}
                                format="DD-MM-YYYY"
                            />
                        </div>
                        {errors.edate && <div className="text-danger fs-8 mt-1">{errors.edate}</div>}
                    </div>
                </div>
            )}
            <label className='text-red fs-4 font-w600 mb-3'>Document Attachment</label>
            <div className='row'>
                <div className="col-lg-6 mb-3">
                    <label className="text-black font-w500 fs-7">Document Type</label>
                    <Select placeholder="Selcet Document Type"
                        isMulti
                        onChange={handledoctypechange}
                        value={selectedOptionsDoctype}
                        options={doctypeopt}
                    />
                </div>
                <div className='col-lg-6 mb-4'>
                    <label className="text-black font-w500 fs-7">Attachment</label>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>File Type: jpg, png, pdf, docx<br></br>Maximun File Size: 5Mb</span></Tooltip>} >
                        <Button variant="tp-btn-light px-2 py-1" style={{ color: 'black' }}>
                            <span><i class="fa-solid fa-circle-info fs-6 mt-1"></i></span>
                        </Button>
                    </OverlayTrigger>
                    <div className='mt-2'>
                        <FileUpload maxFiles='4' value={files} onChange={handleFileChange} />
                    </div>
                    {fileerrors.length > 0 && (
                        <div className="text-danger mt-2">
                            {fileerrors.map((error, index) => (
                                <div key={index}>{error}</div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                <Link to={'/manage-vehicles'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                <Button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Vehicle</Button>
            </div>
        </>
    )


}
export default EditVehicle;